<template>
  <div class="form-group form-group-default">
    <label>{{ label }}</label>
    <div class="controls">
      <input v-validate="validations" v-if="type == 'text'" type="text" v-model="value" :name="name" :placeholder="placeholder" class="form-control" :required="required">
      <input v-if="type == 'password'" type="password" v-model="value" :name="name" :placeholder="placeholder" class="form-control" :required="required">
    </div>
    <label class="error" v-show="errors.any()">{{ errors.first(this.name) }}</label>
  </div>
</template>

<script>
  export default {
    name: 'PagesInput',
    props: {
      initialValue: {
        type: String
      },      
      label: {
        type: String,
        default: "Label me"
      },
      name: {
        type: String,
        default: ""
      },
      type: {
        type: String,
        default: "text"
      },
      placeholder: {
        type: String,
        default: "Enter text"
      },
      required: {
        type: Boolean,
        default: false
      },
      validations: {
        type: String,
        default: ''
      }
    },
    mounted() {
      this.value = this.initialValue;
    },
    data: () => ({
      value: ''      
    })
  }
</script>


// WEBPACK FOOTER //
// input.vue?2ef8302a